import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
  & > *:not(:last-child) {
    margin-bottom: 16px;
  }

  .div-button {
    display: flex;
    justify-content: space-between;
  }
  .left-icon {
    width: 14px;
    margin-right: 17px;
    color: #323e48;
  }
  .right-icon {
    width: 14px;
    margin-left: 17px;
    fill: #fff;
  }

  .add-recap-bloc {
    background-color: #ffffff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    padding: 24px;
    display: grid;
  }
  .update-button {
    padding-top: 10px;
  }
  .add-recap-bloc-title {
    color: #2b2727;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .validation-buttons-wrapper {
    width: 100%;
    padding: 16px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .appeal-add-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-top: 16px;
  }
  .document-recap-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .support-document-info {
    margin-top: 30px;
  }
  .button {
    float: right;
  }
  .item-container {
    display: flex;
    align-items: flex-end;
    width: 100%;
    margin: 10px;
  }
  .item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 36px;
    color: #2b2727;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    margin-right: 12px;
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .field {
    width: 200px;
    border-bottom: 1px solid #dddddd;
    margin-right: 24px;
  }
  .label {
    color: #8b8b8b;
    font-size: 11px;
  }
  .value {
    padding: 8px 0;
    border-radius: 2px;
    font-weight: bold;
    font-size: 13px;
    color: #2b2727;
  }
`;
